// import firebase from 'firebase/app';
// import 'firebase/firestore';
// import 'firebase/auth';

// var config = {
//     apiKey: "AIzaSyB76_l8RqvkAGrLo2TcGFLjCHRxY5yeR78",
//     authDomain: "cromafan-01.firebaseapp.com",
//     databaseURL: "https://cromafan-01.firebaseio.com",
//     projectId: "cromafan-01",
//     storageBucket: "cromafan-01.appspot.com",
//     messagingSenderId: "459625004698",
//     appId: "1:459625004698:web:3191cef0d0378b12"
//   };

//   firebase.initializeApp(config);
//   firebase.firestore().settings({ timestampsInSnapshots: true });
  
  
  import firebase from 'firebase';
  import * as admin from 'firebase-admin';
 
const config = {
  apiKey: "AIzaSyA14NQyxbExfJKN8HJuv6AV4XI3ehUUtK4",
  authDomain: "chromafan-da.firebaseapp.com",
  databaseURL: "https://chromafan-da.firebaseio.com",
  projectId: "chromafan-da",
  storageBucket: "gs://chromafan-da.appspot.com/",
  messagingSenderId: "217355835346",
  appId: "1:217355835346:web:d97e53dd9f95e138"
};
const Admin_config ={

    "type": "service_account",
    "project_id": "chromafan-da",
    "private_key_id": "8239ddbbca1f70f80712f3e9e401a709e94853d5",
    "private_key": "-----BEGIN PRIVATE KEY-----\nMIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQCuBeEdLeDLxmNQ\nj2pEvDsXLVGV0aSSOkcVgVYqgq0rX036hA51VuioI00NcuVj9MRXCGK8X6v86fIa\ndCXyywpH+9f0bq6V4yQQW1G8A0tuL4Ob4paAINcbKoJL/rIa+LMZ2UxWpXSBmGv+\nDJ3RDdOF2b13hl8aXsU+d3+mrx1ilF+WXZyvg5swZoflkUd2XjE+3jIdY9QvHp7d\no+/sp80v/gG7EBgBgSPtUNJ8EIkijZWPJtYaTTrWxMmVvM7ZWXHA3dLLI8gHX87M\n+FJGhDY8Ovtr/zk4QPWXDEDUaYE4DL1xzGaj2/znQCOqXqYThXfJKx5/P4RSp7SM\nfEGDp+W/AgMBAAECggEACDeJ2h1c9HJBJUAoVeeHaMBAjnDwMuFikt7hCS/Tam1d\nGruajSrV4H6OOFjZAP/BN5TTSK7BybboMhyS4CR7L0vydf2166jmfok5UkXbjW/b\n6IPp9FHYplU7Asibc0+T8WADzUGRvz7Jtpy05PagqrzNx/OF0RJxgNIWqnGxUwK3\nks7D4Cb44PHXWDyDYeqVfD3Z+TrpwRZi/5HP174wRqdFBmwlvf1Xsr8FcKAbFkG9\ncoTnu4+tMax3B5/j4fML+MH9/9kwshbESpzT7GdMTLPxd+kiBNn8uc4kuAaA090O\nbZO8uDcFpTgokgoRNMuchP55tDTtVzWKTMRFBJQrWQKBgQDXqIbixZR6lF61mjIF\nTtWMX5b7IDgrYL6aOdwIX/PH4K/zKfGiSg9akL4wIZDJS/i1aL3eWaWkHwHryAue\neAulLWWTR54rKv8TkXt3hXgHEdt0PmVFAjidtudKPQtf2VWJKsN0O65txmC3cir1\n4ksCXuyU4uU7ZKnhylNmL9ha5wKBgQDOk4OHVTPppN07+OeVV7mrDMAaZl4qcKIc\nOH/F/8ZCtOPxuHEMrsreU180JgEzQRt/YP5FGwAgmG+LBvzNHtaYbr3iILA2tfQ+\nh+Bp+jw7aLrDIFC0Y13ghF5/iFWUiZ6RlT10Sv8ehDQHZlo4CsZy4hNLzF13SX90\n1mF1ysHbaQKBgQCWgPWJw4votC0YngD0tVzRN1Dd91Fb7It4hJKrgZNXVdZVZFtP\nAFKQyN0CKBqscQmkSPHhAD1aOY2UqCp7sJmn7/Oogl2/EKWtWWWKNypZ/Ltj97uj\nGna6ko/9vnZ2sO1B6gc30gLcd4q9275hlUj14ZtIGMUT2x+4BQSJFzDt1wKBgBkO\nQVzP080aBw94IDa3/jgmAsLw+ajyImeD3tOYM2bx49f0xBmCte6DdD+yAGFEG162\n2ABvxvMtKhJV1aHXhLXWcMeVqWnpZeeTuX+BL38RM93o9ID8sG1EAOY9Fgw/KPGF\nhX+ufQUpidn/6x9zByD2FNsTvZ5zVrdILWgJILxJAoGBAKvG4FA0r9JQ954EsuVA\nVV9y0B9yFsQ/3i/YhReZcgrKSxoQbMIRs532M1GnJCzFouSF2S4zGq2NpyStQ07G\nIDUA0USOY+kkcgZO9lm6O16Ei/UJUt5h6mF4tQZXYvoQssxGVRw48I1LIqGjIKn5\nSFWjBbPshJM4Vjb//cWn2rSw\n-----END PRIVATE KEY-----\n",
    "client_email": "firebase-adminsdk-s6nh8@chromafan-da.iam.gserviceaccount.com",
    "client_id": "101104715101577638306",
    "auth_uri": "https://accounts.google.com/o/oauth2/auth",
    "token_uri": "https://oauth2.googleapis.com/token",
    "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
    "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-s6nh8%40chromafan-da.iam.gserviceaccount.com"
  
}
 

admin.initializeApp({
  credential:admin.credential.cert(Admin_config) ,
  databaseURL: config.databaseURL
});
firebase.initializeApp(config);
export {firebase, admin}; 